import { useQueryParam, StringParam, withDefault } from 'use-query-params'

const useKeyToken = () => {
  const [key] = useQueryParam('key', withDefault(StringParam, ''))
  const [token] = useQueryParam('token', withDefault(StringParam, ''))
  return { key, token }
}

export default useKeyToken
